/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.chat.ChatRole
*/
export var ChatRole;
(function (ChatRole) {
    ChatRole["USER"] = "USER";
    ChatRole["ASSISTANT"] = "ASSISTANT";
    ChatRole["SYSTEM"] = "SYSTEM";
})(ChatRole || (ChatRole = {}));
//# sourceMappingURL=ChatRole.js.map